import React from 'react';

function Giftlists() {

    //pull in...

    //gift list items


  return (
    <>
        <div className="kt-subheader kt-grid__item" id="kt_subheader">
            <div className="kt-container">
                <div className="kt-subheader__main">
                    <h3 className="kt-subheader__title">Gift Lists</h3>
                </div>
            </div>

        </div>
        <div className="kt-container kt-grid__item kt-grid__item--fluid">

            <div style={{height: "500px"}}></div>
        </div>
    </>
  );
}


export default Giftlists;